import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loadingRequestSubmit: false,
	loadingVerifySubmit: false,
	loadingUserSubmit: false
};

export default function signUpPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.SIGNUP_REQUEST_OTP_REQUEST:
		case ActionTypes.SIGNUP_REQUEST_OTP_SUCCESS:
		case ActionTypes.SIGNUP_REQUEST_OTP_ERROR:
		case ActionTypes.SIGNUP_VERIFY_OTP_REQUEST:
		case ActionTypes.SIGNUP_VERIFY_OTP_SUCCESS:
		case ActionTypes.SIGNUP_VERIFY_OTP_ERROR:
		case ActionTypes.CREATE_USER_REQUEST:
		case ActionTypes.CREATE_USER_SUCCESS:
		case ActionTypes.CREATE_USER_ERROR:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_SIGNUP_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_SIGNUP_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
